// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { stockTypeEnumEe62bcf9 } from './StockTypeEnumEe62bcf9';
import { calendarDate } from '../../calendar-date';
import { operatorId } from './Operator';
import { invRecipeId } from './InvRecipe';
import { z } from 'zod';
export const organismId = (z.number());
export const organism = z.object({
    id: organismId,
    nickname: z.string(),
    name: z.string(),
    stock_type: stockTypeEnumEe62bcf9,
    stock_creation_date: calendarDate.nullable(),
    created_by_operator_id: operatorId.nullable(),
    storage_location: z.string().nullable(),
    source_organism_id: organismId.nullable(),
    collection_no: z.string().nullable(),
    modified: z.boolean().nullable(),
    stock_left: z.number().nullable(),
    medium_recipe_id: invRecipeId.nullable(),
});
export const organismInitializer = z.object({
    id: organismId.optional(),
    nickname: z.string(),
    name: z.string(),
    stock_type: stockTypeEnumEe62bcf9,
    stock_creation_date: calendarDate.optional().nullable(),
    created_by_operator_id: operatorId.optional().nullable(),
    storage_location: z.string().optional().nullable(),
    source_organism_id: organismId.optional().nullable(),
    collection_no: z.string().optional().nullable(),
    modified: z.boolean().optional().nullable(),
    stock_left: z.number().optional().nullable(),
    medium_recipe_id: invRecipeId.optional().nullable(),
});
export const organismMutator = z.object({
    id: organismId.optional(),
    nickname: z.string().optional(),
    name: z.string().optional(),
    stock_type: stockTypeEnumEe62bcf9.optional(),
    stock_creation_date: calendarDate.optional().nullable(),
    created_by_operator_id: operatorId.optional().nullable(),
    storage_location: z.string().optional().nullable(),
    source_organism_id: organismId.optional().nullable(),
    collection_no: z.string().optional().nullable(),
    modified: z.boolean().optional().nullable(),
    stock_left: z.number().optional().nullable(),
    medium_recipe_id: invRecipeId.optional().nullable(),
});
//# sourceMappingURL=Organism.js.map